// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.italogspg-inline-1 {
  padding: 0;
}

.italogspg-inline-2 {
  font-size: 11px;
  color: #94a3b8;
}

.italogspg-inline-3 {
  font-weight: 600;
}

.italogspg-inline-4 {
  font-size: 11px;
  color: #475569;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/ITAdmin/ITALogsPg.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":[".italogspg-inline-1 {\n  padding: 0;\n}\n\n.italogspg-inline-2 {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.italogspg-inline-3 {\n  font-weight: 600;\n}\n\n.italogspg-inline-4 {\n  font-size: 11px;\n  color: #475569;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
